import styled, { keyframes } from 'styled-components';
import { media } from '@simplywallst/ui-core';

import { Row } from '@simplywallst/ui-core';

interface Props {
  fullscreen: boolean;
  isLoading: boolean;
  scrollable?: boolean;
  //  dropOpacity only when a blur is applied (these 2 applications *currently* work in tandem)
  dropOpacity?: boolean;
}

const onEnter = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

export const Wrapper = styled(Row)<Props>`
  top: 0;
  position: fixed;
  background: ${({ theme, dropOpacity, fullscreen, isLoading }) =>
    fullscreen && !isLoading
      ? theme.color.white
      : theme.color.spaceGrayRGBA(dropOpacity ? 0.4 : 0.9)};
  animation: ${onEnter} 0.1s linear;
  height: 100%;
  z-index: 9999;
  padding: ${({ theme, fullscreen }) => (fullscreen ? 0 : theme.x2spacePx)}px;
  padding-top: ${({ theme, fullscreen }) =>
    `calc(${fullscreen ? 0 : theme.x2spacePx}px + ${theme.safeAreaInsetTop})`};
  padding-bottom: ${({ theme, fullscreen }) =>
    `calc(${fullscreen ? 0 : theme.x2spacePx}px + ${
      theme.safeAreaInsetBottom
    })`};

  ${({ scrollable }) => `overflow-y: ${scrollable ? 'auto' : 'hidden'};`}

  ${media.mdUp`
		padding: ${({ theme }) => theme.x4spacePx}px;
  `};

  ${media.smDown`
    ${({ scrollable, isLoading }) =>
      scrollable && !isLoading && `display: block;`}
	`};

  ${media.lgUp`
    background: ${({ theme, dropOpacity }) =>
      theme.color.spaceGrayRGBA(dropOpacity ? 0.4 : 0.9)};
	`};
`;

interface ModalBodyProps {
  scrollable?: boolean;
}

export const ModalBody = styled('section')<ModalBodyProps>`
  position: relative;
  background: white;
  color: black;
  ${({ scrollable }) =>
    scrollable &&
    `
    overflow-y: auto;
    overflow-x: hidden;
  `}
  font-size: ${({ theme }) => theme.x2space}rem;
  line-height: 1.5;
  padding: ${({ theme }) => theme.x4spacePx}px
    ${({ theme }) => theme.x3spacePx}px;
  ${media.lgUp`
    max-height: calc(480px - 88px); /* 130px = header height + footer height */
  `};

  ${media.mdDown`
    position: absolute;
    width: 100%;
    z-index: 0;
    top: ${({ theme }) => theme.x8spacePx}px;
    /* Height: 100% parent height - header height - footer height*/
    height: ${({ theme }) =>
      `calc(100% - ${theme.x8spacePx}px - ${theme.x9spacePx}px)`};
    -webkit-overflow-scrolling: touch;
	`};
`;
